import { useState } from 'react';
import { useDispatch } from 'react-redux';

// firebase
import { signInWithEmailAndPassword } from 'firebase/auth';
import { auth, db } from '../utils/firebase/firebase.utils';
import { fetchUserFromFirestore } from '../utils/firebase/user';
import { syncPublicProfile } from '../utils/firebase/publicProfile';
import { doc, setDoc } from 'firebase/firestore';

// actions
import { setUser } from '../store/user/user.action';

export const useSignIn = () => {
    const dispatch = useDispatch();
    const [error, setError] = useState(null);
    const [isPending, setIsPending] = useState(false);

    const signIn = async (email, password) => {
        setError(null)
        setIsPending(true)

        try {
            const res = await signInWithEmailAndPassword(auth, email, password)

            const user = res.user;

            // Get role from custom claims (secure, server-set)
            let role = "user";
            try {
                const tokenResult = await user.getIdTokenResult(true);
                role = tokenResult?.claims?.role || "user";
            } catch (err) {
                // Could not get role from token - use default
            }
            
            // Fetch complete user data from Firestore (including username)
            let userDoc = await fetchUserFromFirestore(user.uid);
            
            // If user document doesn't exist, create it
            if (!userDoc) {
                const newUserData = {
                    email: user.email,
                    teamIndex: 0,
                    collectionCardCount: 0,
                    tokens: 0,
                    createdAt: new Date().toISOString()
                };
                
                try {
                    await setDoc(doc(db, 'users', user.uid), newUserData);
                    await syncPublicProfile(user.uid, newUserData);
                    userDoc = newUserData;
                } catch (createError) {
                    // Continue with basic user data even if document creation fails
                    // This allows old accounts to sign in even if document creation fails
                    userDoc = {
                        email: user.email,
                        teamIndex: 0,
                        collectionCardCount: 0,
                        tokens: 0
                    };
                }
            }
            
            const userData = {
              uid: user.uid,
              email: user.email,
              role,
              ...userDoc // Include all Firestore data (username, teamIndex, etc.)
            };

            dispatch(setUser(userData))

            setError(null)
            setIsPending(false)
        } catch (err) {
            // Extract error code from Firebase error
            // Firebase v9+ errors have a 'code' property
            const errorCode = err.code || err.message || 'unknown-error';
            setError(errorCode);
            setIsPending(false);
        }
    }

    return { error, isPending, signIn }
}